import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/languex-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/about-us-excellence.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/about-us-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/about-us-human-connection.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/about-us-our-roots.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/about-us-team.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/academicHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/academicLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/academicLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/academicLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/academicLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/AccordingIMGEcommerce.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/advantage1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/advantage2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/advantage3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Affidavits.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/AlexAvatar.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/all-documents-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/angelicaMia.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/approval_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/arbIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/arrow-right.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ArrowLanguageHeader.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/automotiveHeroImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/avatar-women.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Bank_statements.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/basil_document-solid.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/bg_line_Urgent.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/bg_standart_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/bg_standart_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/bg_standart_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/bg_standart_4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Birth_certificate.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/blank_bank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/blank_cap.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/blank_web.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/book.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/brochure.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/built_in_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/carbon_delivery-parcel.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/certifiedType.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/check_black_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/chIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/confirm_star_circle.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/constLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/constLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/constLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/constLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/constLogo5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ConstructionImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Contract.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/dedicated_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/deliveryBox.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Diploma.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/doc_big_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/docImage.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/docxIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/E-learning.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/EcommerceIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ecommerceLogo6.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/education-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/eLearning.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elit_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Ellipse.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elment0.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elment1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elment2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elment3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/elment4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Email.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/emailImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/employee_handbook.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/EnergyAccordinIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/EnergyHeroImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/energyLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/energyLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/enterprise_card_icon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/enterpriseType.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/eplorer.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/experince_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/expert1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/expert2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/expert3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/expert4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/expert5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/fa-solid_university.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Financial_Report.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Financial_Statement.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/flowbite_language-outline.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/fluent_building-government-20-regular.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/footerBgImageMobile.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/footerLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/footerLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/footerLogo3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/footerLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/fotterBgImage.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/game.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gamingLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gamingLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gamingLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gamingLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/GammingHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gericon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gg_dollar.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gridImage1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gridImage2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/gridImage4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/header_bg_horizontal.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/header_bg_vertical.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/header_icon_group2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/header_icon_group3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerGirl.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerGirl2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerGirls.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerGroupIcno4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerIconGroup.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerMen.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/HeaderMenIcon1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/HeaderMenIcon2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerPhotoIcon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/headerPhotoIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/helthcare-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/hero-home-mobile.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/hero-home.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/heroBgSpanish.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/heroIMGManufacturing.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/humanIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/icon-park-solid_check-one-black.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/icon-park-solid_check-one.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAcademic1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAcademic2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAcademic3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAcademic4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAcademic5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAutomotive2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAutomotive3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAutomotive4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAutomotive5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconAutomotive6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconCheck.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconChecklight.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconConst2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconConst3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconEcommerce1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconEcommerce2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconEnergy2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconEnergy3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconGame1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconGame2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconGame3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconGame4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconGame5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconIncurance1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMarketing1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMarketing2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMarketing3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMarketing4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMarketing5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMedia1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconMedia2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/iconTech1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/image_card_1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/image_card_2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/image_card_3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/image_card_4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imageHeaderLanguage.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ImageMap.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ImageMap2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ImageMap3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imageTehnical.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/img1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/img2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/img3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/img4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/img5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase10.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase11.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase12.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase6.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase7.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase8.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/imgUseCase9.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/industriesHeroImg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceLogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/insuranceLogo5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/ix_certificate-success.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/languages-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LastBlockBG.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/law-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftAcademicIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftGamingIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftIncuranceIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftManufactureIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftMarketingIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftMediaIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftrealEstateIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftTechIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/leftTourismIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/License.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/line-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/line-bg2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Logo_languex.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logob6_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoBlock6_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoBlock6_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoBlock6.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoHeaderAbout.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoHeaderLanguage.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoHeaderSpanish.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LogoIpsum.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LogoIpsum2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LogoIpsum3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LogoIpsum4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/LogoIpsum5.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/logoWhite.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mage_file-2-fill.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/majesticons_briefcase-line.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Manual.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/manufactureLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/manufactureLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/marketingHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Marriage_Certificate.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/material-symbols_verified-rounded.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mdi_users-add-outline.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mediaHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mediaLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mediaLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Medical_Records.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/MenuBgImage1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/MenuBgImage2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mingcute_paper_blue.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/mingcute_paper-line.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/nimbleMotors.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/notarized_second_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Notarized-SecondBlogImage.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/notarizetion_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/octicon_law-16.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/official_document_icon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/panent.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Passport.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Patent.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/pdfIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Porsche_Wortmarke_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Press_release.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/pricing_Footer.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/quality_second_image_right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateIcon1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateIcon2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/realEstateLogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/red_file.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/second_group_urgent.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/security-support1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/security-support2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/security-support3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/security-trust.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-certified-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-enterprise-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-notarized-ensure-compliance.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-notarized-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-quality-promises.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-standard-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-urgent-ensure-compliance.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/services-urgent-hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/shield.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/shutterImg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/simplify_card_1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/simplify_card_2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Software.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/solar_buildings-linear1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/solar_buildings-linear2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/solar_buildings-linear3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/solar_wallet-money-linear.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/spIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/standart_service_card_icon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/standartType2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/star_x2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/support-form.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/support-grid.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tdesign_task.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/techLogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/techLogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/technologyHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/teenyicons_floorplan.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tourismHeroIMG.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tourismlogo1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tourismlogo2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tourismlogo3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/tourismlogo4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Transcript.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg10.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg11.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg12.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg13.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg14.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg15.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg6.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg7.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg8.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/translatorsImg9.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/trust_logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/trustpilot-2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/urgent_group_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/useCaseHeroIMG.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/usIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Video.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/volvo-wordmark-black.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/Website.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets/woman-industry.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/get-quote/components/ConfirmedOrderCard/ConfirmedOrderCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/get-quote/QuoteOrder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/order/OrderCard/components/OrderCardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/order/OrderCard/components/OrderCardHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/order/OrderCard/components/OrderCardItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/order/OrderCard/components/OrderCardList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/order/OrderCard/OrderCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/ui/user-meta.tsx");
